import React from 'react'
import { Provider } from 'react-redux'

import IdFinder from '../id_finder'
import ProductButton from 'store/modules/product/components/ProductButton'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export default class Button extends React.Component {
  static displayName = 'ProductButtonContainer'

  render = () => {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <IdFinder {...Object.assign({}, this.props)} hideOnLoad>
              <ProductButton />
            </IdFinder>
          </div>
        </Themed>
      </Provider>
    )
  }
}
